module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Toscana (2).0202fef3.jpg";